import React, { Component, Fragment, useEffect, useRef, useState } from "react";
import Reload from "../../../assets/images/reloadApi.svg";
//
function useKey(key, cb) {
  const callbackRef = useRef(cb);
  useEffect(() => {
    callbackRef.current = cb;
  });
  useEffect(() => {
    function handle(event) {
      if (event.code === key) {
        callbackRef.current(event);
      }
    }
    document.addEventListener("keypress", handle);
    return () => document.removeEventListener("keypress", handle);
  }, [key]);
}

function SaveAs(props) {
  const [displayMenu, setDisplayMenu] = useState(false);
  const handleEnter = () => {
    setDisplayMenu(!displayMenu);
  };
  useKey("KeyS", handleEnter);

  return (
    <Fragment>
      <div className="saveAsOverlay" onClick={props.close}></div>
      <div className="saveAsBlockWrap">
        <ul className="save-menu">
          <Fragment>
            <li className="saveBlock">
              <span onClick={() => props.selectedCategory("custom")}>
                Save As Block
              </span>
              {displayMenu && (
                <div>
                  <div className="selectWrapper">
                    <select onChange={props.selectedCategory}>
                      <option>Select Category</option>
                      <option value="hero/header">Hero / Header</option>
                      <option value="featured content">Featured Content</option>
                      <option value="video">Video</option>
                      <option value="cta/informative">CTA / Informative</option>
                      <option value="lists">Lists</option>
                      <option value="footer">Footer</option>
                    </select>
                  </div>
                </div>
              )}
              <div className="clearfix"></div>
            </li>
          </Fragment>
          {
            <li
              className={
                "saveTemplate" +
                (props.templateLoader || props.templateSaved ? " saving" : " ")
              }
              onClick={props.saveTemplate}
            >
              {props.templateLoader ? (
                <Fragment>
                  <div className="loading"></div>
                  <small>Please wait...</small>
                </Fragment>
              ) : props.templateSaved && !props.templateLoader ? (
                <div className="wrapperSaved">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 98.5 98.5"
                    enableBackground="new 0 0 98.5 98.5"
                  >
                    <path
                      className="checkmark"
                      fill="none"
                      strokeWidth="8"
                      strokeMiterlimit="10"
                      d="M81.7,17.8C73.5,9.3,62,4,49.2,4
C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"
                    />
                  </svg>
                </div>
              ) : !props.templateSaved && !props.templateLoader ? (
                "Save as Template."
              ) : null}
            </li>
          }
          <li
            className={
              "saveFile " +
              (props.saved || props.clickedSave || props.errorInSave
                ? " saving"
                : " ") +
              (props.snapshotApiError ? " activeSaveAgain" : " ")
            }
          >
            {props.clickedSave && !props.saved && (
              <Fragment>
                {!props.snapshotApiError ? (
                  <div className="loading"></div>
                ) : (
                  <img
                    style={{ width: "16px" }}
                    onClick={() => {
                      props.saveAsMultimedia;
                      props.saveReloadAgain(true);
                    }}
                    className="reloadSave"
                    src={Reload}
                  />
                )}
                {!props.snapshotApiError && (
                  <small>
                    {props.creatingSnapshot
                      ? "Creating snapshot."
                      : "Please wait..."}
                  </small>
                )}

                {props.snapshotApiError && (
                  <small className="reloadSave" style={{ fontSize: "9px" }}>
                    <span style={{ color: "green" }}>
                      Data is stored successfully
                    </span>
                    ,{" "}
                    <span style={{ color: "red" }}>
                      {" "}
                      Failed to generate snapshot
                    </span>
                    .
                  </small>
                )}
              </Fragment>
            )}
            {props.saved ? (
              <div className="wrapperSaved">
                <svg
                  version="1.1"
                  id="Layer_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 98.5 98.5"
                  enableBackground="new 0 0 98.5 98.5"
                >
                  <path
                    className="checkmark"
                    fill="none"
                    strokeWidth="8"
                    strokeMiterlimit="10"
                    d="M81.7,17.8C73.5,9.3,62,4,49.2,4
	C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"
                  />
                </svg>
              </div>
            ) : null}
            {props.errorInSave && (
              <img
                onClick={props.saveAsMultimedia}
                className="reloadSave"
                src={Reload}
              />
            )}
            {!props.clickedSave && !props.saved && !props.errorInSave && (
              <span onClick={props.saveAsMultimedia}>Save as File</span>
            )}
          </li>
        </ul>
      </div>
    </Fragment>
  );
}

export default SaveAs;
